import * as marietta from '../..';
import { CONTROL_ACTIONMODE } from '../Constants';
import { SVGSprite } from '../flash/display';

class ItemControllerFittingDragInput {
  rect: SVGElement;

  dragImage: Element;

  startPoint: marietta.core.Point;

  endPoint: marietta.core.Point;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  private static _instance: ItemControllerFittingDragInput = null;

  public spt: SVGSprite;

  moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   */
  constructor() {
    if (ItemControllerFittingDragInput._instance) {
      throw new Error('must use the getInstance.');
    }
    //            this.initMe();
  }

  /**
   * シングルトン
   */
  static getInstance(): ItemControllerFittingDragInput {
    if (ItemControllerFittingDragInput._instance === null) {
      ItemControllerFittingDragInput._instance = new ItemControllerFittingDragInput();
    }
    ItemControllerFittingDragInput._instance.initMe();
    return ItemControllerFittingDragInput._instance;
  }

  /**
   * 初期化
   */
  initMe() {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchstart', this.startDrag, { passive: false });
    } else {
      stage.addEventListener('mousedown', this.startDrag);
    }
    ua = null;
  }

  /**
   * ドラッグ開始
   */
  startDrag = (e: MouseEvent) => {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode !== CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_FITTING) return;
    e.preventDefault();
    const floor: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    // ドラッグイメージの作成
    this.dragImage = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.dragImage.setAttribute('id', 'dragImageFitting');
    tarLayer.viewObj.appendChild(this.dragImage);
    this.spt = new SVGSprite(this.dragImage);

    // 開始地点の座標
    this.startPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.startPoint.x = Math.round(this.startPoint.x / snapUnit) * snapUnit;
    this.startPoint.y = Math.round(this.startPoint.y / snapUnit) * snapUnit;

    // ドラッグエリアの作成
    this.rect = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.rect.setAttribute('fill', '#00FF26');
    this.rect.setAttribute('fill-opacity', '0.3');
    this.rect.setAttribute('stroke', '#00FF26');
    this.rect.setAttribute('stroke-width', '1');
    this.rect.setAttribute('id', 'dragRect');
    this.dragImage.appendChild(this.rect);

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.addEventListener('touchmove', this.moveDrag, { passive: false });
      document.addEventListener('touchend', this.endDrag, { passive: false });
    } else {
      document.addEventListener('mousemove', this.moveDrag);
      document.addEventListener('mouseup', this.endDrag);
    }

    const scope: ItemControllerFittingDragInput = this;
    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.moveDragHandler();
      }
    };

    ua = null;
  }

  private moveDragHandler(): void {
    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
    this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;

    // ドラッグエリアの座標作成
    let pathList = `M ${this.startPoint.x} ${this.startPoint.y} `;
    pathList += `L ${this.startPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.startPoint.y} `;
    pathList += 'Z';
    this.rect.setAttribute('d', pathList);
  }

  /**
   * ドラッグ中の制御
   */
  moveDrag = (e: MouseEvent) => {
    e.preventDefault();
    this.moveMouseEvent = e;
  }

  /**
   * ドラッグ終了
   */
  endDrag = (e: MouseEvent) => {
    e.preventDefault();
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      //                document.removeEventListener("touchstart", this.startDrag );
      document.removeEventListener('touchmove', this.moveDrag);
      document.removeEventListener('touchend', this.endDrag);
    } else {
      //                document.removeEventListener("mousedown", this.startDrag );
      document.removeEventListener('mousemove', this.moveDrag);
      document.removeEventListener('mouseup', this.endDrag);
    }
    ua = null;

    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
    this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;

    // 開始地点と終了地点が等しいなら何もしない
    if (this.startPoint.x === this.endPoint.x || this.startPoint.y === this.endPoint.y) {
      // 作成用モジュールなど削除する
      this.viewObj.remove();
      return;
    }
    // 形状作成終了
    this.endMakeShape();
  }

  /**
   * 形状作成の終了
   */
  endMakeShape() {
    marietta.webcad.WebCADGlobal.cadAPIManager.createFittingFromPoint(this.startPoint, this.endPoint);

    //見積リスト更新
    marietta.webcad.WebCADGlobal.quotationItemList.createData();

    // 作成用モジュールなど削除する
    this.viewObj.remove();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * HTMLElementの取得
   */
  public get viewObj(): HTMLElement {
    return this.spt.element;
  }
}
export default ItemControllerFittingDragInput;
